module.exports = __webpack_public_path__ + "img/create.5046660d.svg";